module.exports = __webpack_public_path__ + "img/datav-tab.ebc6bad9.png";